export default __webpack_public_path__ + "static/io_steve_logo-528d4cee012e6108f281514863d93cd0.png";